import { Tag } from "antd";

const statusColor = {

    OPEN:
        "blue",

    NEGOTIATING:
        "orange",

    AWAITING_CONFIRMATION:
        "gold",

    ORDER_CREATED:
        "green"
};

export default function ConversationStatusBadge({
                                                    status
                                                }) {

    return (

        <Tag
            color={
                statusColor[
                    status
                    ]
            }
        >
            {status}
        </Tag>
    );
}